const GNCPrefixOptions = ['Mx.', 'M', 'Ind.', 'Other'];

export const liberalPrefixOptions = options => {
    const ret = JSON.parse(JSON.stringify(options));
    GNCPrefixOptions.forEach(prefix => {
        if (!ret.find(p => p === prefix)) ret.push(prefix);
    });
    return ret;
};
